import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-cancel-statement-dialog',
  templateUrl: './cancel-statement-dialog.component.html',
  styleUrls: ['./cancel-statement-dialog.component.css']
})
export class CancelStatementDialogComponent implements OnInit {
  cancelInvoiceForm: UntypedFormGroup;
  formErrors = {
    'cancelReason': ''

  };
  ValidationMessages = {
    'cancelReason': {
      'required': 'Reason is required'
    }
  };
  disableConfirmbtn = false;
  api_error: any;
  api_success: string;
  constructor(private formbuilder: UntypedFormBuilder, @Inject( MAT_DIALOG_DATA) public data: any,
   private accountService: AccountService, private dialogRef: MatDialogRef<any>) {


    this.cancelInvoiceForm = this.formbuilder.group({
      'uuid': this.data,
      'cancelReason': ['', [Validators.required]]
    });
  }


  ngOnInit() {
  }
  onCancel() {
    this.api_error = '';
    this.api_success = '';
    this.logValidationErrors();
    if (this.cancelInvoiceForm.valid) {
      this.disableConfirmbtn = true;
    console.log('formvalue......' + JSON.stringify(this.cancelInvoiceForm.value));
    this.accountService.cancelInvoice(this.cancelInvoiceForm.value)
    .subscribe(res => {
     this.api_success = 'Invoice Cancelled Successfully';
     setTimeout(() => {
      this.dialogRef.close('reloadlist');
      }, 2000);

    },
    ( error => {
      this.api_error = error.error;
      this.disableConfirmbtn = false;

    }));

  }
}
  logValidationErrors(group: UntypedFormGroup = this.cancelInvoiceForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.ValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });


  }

}
